import React, { useEffect, useState } from "react";
import { Card, Descriptions, Spin, message, Button, Image, Table } from "antd";
import { useParams, useNavigate } from "react-router-dom";  
import { getCandidateApplicationsApi, getCandidatesApi } from "../../../apiservice/ats";

const ViewCandidate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [candidate, setCandidate] = useState(null);
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadCandidate = async () => {
    try {
      setLoading(true);

      // Fetch candidate data
      const res = await getCandidatesApi({ id });
      const data = res?.data;
      if (!data) {
        message.error("Candidate not found");
        setLoading(false);
        return;
      }
      const candidateData = Array.isArray(data) ? data[0] : data;
      setCandidate(candidateData);

      // Fetch candidate applications
      const appRes = await getCandidateApplicationsApi({ candidateId: id });
      setApplications(appRes?.data || []);

      setLoading(false);
    } catch (err) {
      console.error("Error loading candidate:", err);
      message.error("Failed to load candidate");
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCandidate();
  }, [id]);

  if (loading) return <div style={{ textAlign: "center", padding: 40 }}><Spin size="large" /></div>;
  if (!candidate) return <div>Candidate not found</div>;

  // Columns for applications table
  const applicationColumns = [
    { title: "Job Title", dataIndex: "job_title", key: "job_title" },
    { title: "Status", dataIndex: "status", key: "status" },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Button
          type="link"
          onClick={() => navigate(`/ats/applications/${record.id}`)}
        >
          View
        </Button>
      )
    }
  ];

  return (
    <Card
      title={`Candidate: ${candidate.name || "—"}`}
      extra={
        <Button
          type="primary"
          onClick={() => navigate(`/ats/candidates/${id}/edit`)}
        >
          Edit
        </Button>
      }
    >
      {candidate.photo && (
        <div style={{ marginBottom: 20 }}>
          <Image
            width={150}
            src={candidate.photo}
            alt="Candidate Photo"
            placeholder
          />
        </div>
      )}

      <Descriptions bordered column={1} style={{ marginBottom: 20 }}>
        <Descriptions.Item label="Name">{candidate.name || "—"}</Descriptions.Item>
        <Descriptions.Item label="Email">{candidate.email || "—"}</Descriptions.Item>
        <Descriptions.Item label="Job Title">{candidate.job_title || "—"}</Descriptions.Item>
        <Descriptions.Item label="Status">{candidate.status || "—"}</Descriptions.Item>
        {candidate.resume && (
          <Descriptions.Item label="Resume">
            <a href={candidate.resume} target="_blank" rel="noopener noreferrer">
              View / Download Resume
            </a>
          </Descriptions.Item>
        )}
      </Descriptions>

      <Card type="inner" title="Job Applications">
        <Table
          dataSource={applications}
          columns={applicationColumns}
          rowKey="id"
          pagination={false}
        />
      </Card>
    </Card>
  );
};

export default ViewCandidate;
